//
// locale_ja.js
// automatically generated by generateLocalePacks.js
//
import messages from '../locales/ja.json';
import { setLocale } from '../locales';
setLocale({messages, locale: 'ja'});
